// The activity form's Quotation label: "Quote/Ver: Q55678-1 >> Date: 03/04/2026 >> Value: £795".
// A record opened from a list row carries its quote without a date (the row has none), so a
// missing part is left out rather than printed as "undefined".
export function quoteLabel(quote) {
  let label = "Quote/Ver: " + quote.quoteVer;
  if (quote.quoteVerDate) label += " >> Date: " + quote.quoteVerDate;
  if (quote.productValue !== undefined && quote.productValue !== null) {
    label += " >> Value: £" + quote.productValue.toString();
  }
  return label;
}
